import React from 'react';
import PublicServiceTracking from '../public-service-tracking';

const MesDevisPage = () => <PublicServiceTracking view="devis" />;

export default MesDevisPage;
